// extracted by mini-css-extract-plugin
export default {"optOutContianter":"OptOutReason_optOutContianter__7+Ufo"};